<!-- Hero Section -->
<div class="softwaredev-section-bg">
  <section class="softwaredev-section container py-5">
    <div class="glass-panel-container">
      <div class="row align-items-center">
        <div class="col-lg-5">
          <h1 class="softwaredev-heading mb-3">
            Tech Geek Ed. 3
          </h1>
          <!-- <h3 class="softwaredev-subheading2 mb-4">
            Discover the fresh stories of Kalpita Technologies.
          </h3> -->
          <div class="mb-5 contact-btn">
            <!-- <button class="btn case-study-btn me-3" (click)="goToCaseStudies()">
              Case Studies
            </button> -->
            <!-- <button class="btn hire-btn hire" (click)="exploreOurSolutions()">
              Explore Our Solutions
            </button> -->
          </div>
        </div>

        <div class="col-lg-7 text-center">
          <img src="../../../../assets/resources/techgeek/tech-geek-3-bannerimg.png" alt="Tech Geek Edition 3"
            class="img-fluid hero-image">
        </div>
      </div>
    </div>
  </section>
</div>
<!-- TL;DR Section with Image Icon -->
<section class="takeaways-section py-5">
  <div class="container">
    <h2 class="section-title text-center">TL;DR</h2>
    <div class="takeaways-list">
      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" class="arrow-icon" />
        <p>
          It highlights how technology intersects with creativity, wellness, and user experience, from plant-based
          meditation to holographic dining.
        </p>
      </div>
      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" class="arrow-icon" />
        <p>
          The edition showcases AI-driven tools transforming animation, content creation, and prompt engineering.
        </p>
      </div>
      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" class="arrow-icon" />
        <p>
          It dives into community-driven digital platforms that are redefining fandom and cultural exploration.
        </p>
      </div>
      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" class="arrow-icon" />
        <p>
          A practical comparison of modern API technologies helps developers choose the right system architecture.
        </p>
      </div>
      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" class="arrow-icon" />
        <p>
          Overall, the edition serves as a compact yet insightful guide to trending technologies shaping the digital
          future.
        </p>
      </div>
    </div>
  </div>
</section>
<!-- Key Takeaways Section with Image Icon -->
<section class="takeaways-section pt-0 pb-5">
  <div class="container">
    <h2 class="section-title text-center">Key Takeaways</h2>
    <div class="takeaways-list">

      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" class="arrow-icon" />
        <p>
          <strong>Plantwave & Nature Tech:</strong> Transforms plant bio-signals into music, enabling mindfulness and
          meditation through a unique blend of eco-tech and wellness innovation.
        </p>
      </div>

      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" class="arrow-icon" />
        <p>
          <strong>AR & Holographic Dining (HoloLamp):</strong> Reinvents restaurant menus using augmented reality and
          holographic visuals, enhancing customer decision-making and sensory engagement.
        </p>
      </div>

      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" class="arrow-icon" />
        <p>
          <strong>AI-Powered Animation (Wonder Studio):</strong> Automates CG and VFX workflows, making
          professional-quality animation accessible to creators.
        </p>
      </div>

      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" class="arrow-icon" />
        <p>
          <strong>Prompt Crafting for ChatGPT:</strong> Well-structured prompts dramatically improve AI-generated
          results, enabling higher efficiency and customization.
        </p>
      </div>

      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" class="arrow-icon" />
        <p>
          <strong>Digital Culture & Creative Platforms:</strong> Platforms like Weverse and Google Arts & Culture
          connect global communities by blending technology with music, art, and heritage.
        </p>
      </div>

      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" class="arrow-icon" />
        <p>
          <strong>API Technology Comparison:</strong> SOAP, REST, GraphQL, and RPC are clearly compared to help
          developers build scalable, high-performance system architectures.
        </p>
      </div>
    </div>
    <button class="btn case-study-btn" (click)="openModal()">
      Access Your Copy
    </button>
  </div>
</section>
<!-- Relevant Article -->
<app-relevant-techgeek></app-relevant-techgeek>

<!-- MODAL POPUP -->
<div class="modal-overlay" *ngIf="isModalOpen">
  <div class="modal-content-box">
    <button class="close-btn" (click)="closeModal()">&times;</button>

    <div class="modal-header" *ngIf="!submitSuccess">
      <h3>Access Your TechGeek Copy</h3>
      <p>Fill in your details to receive the Tech Geek Edition 3.</p>
    </div>

    <div *ngIf="submitSuccess" class="success-message text-center">
      <i class="ri-checkbox-circle-fill" style="color: #28a745; font-size: 3rem;"></i>
      <h4>Thank you!</h4>
      <p>Check your email for the download link.</p>
      <small style="color: #666;">Please check your spam folder if you don't see it.</small>
    </div>

    <form [formGroup]="downloadForm" (ngSubmit)="onSubmit()" *ngIf="!submitSuccess">
      <div class="form-group">
        <label>Full Name</label>
        <input type="text" formControlName="name" class="form-control" placeholder="Name">
        <div class="error-msg" *ngIf="downloadForm.get('name')?.touched && downloadForm.get('name')?.errors">

          <span *ngIf="downloadForm.get('name')?.errors?.['required']">
            Name is required
          </span>

          <span *ngIf="downloadForm.get('name')?.errors?.['pattern']">
            Name should contain only letters
          </span>

        </div>
      </div>

      <div class="form-group">
        <label>Email Address</label>
        <input type="email" formControlName="email" class="form-control" placeholder="Email">
        <div class="error-msg" *ngIf="downloadForm.get('email')?.touched && downloadForm.get('email')?.errors">

          <span *ngIf="downloadForm.get('email')?.errors?.['required']">
            Email is required
          </span>

          <span *ngIf="downloadForm.get('email')?.errors?.['pattern']">
            Enter a valid email address
          </span>

        </div>
      </div>

      <div class="alert alert-danger" *ngIf="errorMessage">{{ errorMessage }}</div>

      <div class="modal-footer">
        <button type="submit" class="submit-btn" [disabled]="isSubmitting">
          {{ isSubmitting ? 'Processing...' : 'Download Now' }}
        </button>
      </div>
    </form>
  </div>
</div>